module.exports = __webpack_public_path__ + "img/arrow_left.3d0a99ea.png";